import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=bde758f4&scoped=true&"
import script from "./MenuLayout.vue?vue&type=script&lang=js&"
export * from "./MenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=bde758f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde758f4",
  null
  
)

export default component.exports